// extracted by mini-css-extract-plugin
export default {"modalAttention":"_2rb3W","desc":"_1j6A_","modalActionWrapper":"_24N51"};